<template lang="pug">
v-container.fill-height.justify-center.align-start(fluid)
    v-card.pa-0.ma-0(flat)
      v-card-title.justify-center.text-h5.font-weight-bold Presťahovali sme sa 🚀
      v-card-text.text-center
        div
          | Mení sa iba adresa, všetko ostatné ostáva tak, ako ste zvyknutí.
        div
      v-card-actions.justify-center.mt-6
        v-btn.two-line-btn(color="primary" x-large @click="redirect")
          span.main-line Prejsť na novú adresu
          span.sub-line {{ redirectAddress }}


</template>

<script lang="ts">
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import store from '@/store'
import { USER_LOGGED_IN } from '@/store/getter-types'
import { CurrentUser } from '@/model/CurrentUser'

@Component({})
export default class RedirectToNewAddressPage extends Vue {
  redirectAddress: string = ''

  redirect() {
    window.location.href = this.redirectAddress
  }

  mounted (): void {
    let user: CurrentUser = store.getters[USER_LOGGED_IN]
    this.redirectAddress = user.redirectAddress!
  }
}
</script>

<style lang="stylus" scoped>
.two-line-btn
  display flex
  flex-direction column !important
  align-items center
  white-space normal
  line-height 1.2

.two-line-btn >>> .v-btn__content
  flex-direction column !important

.main-line
  font-size 1rem
  font-weight 500

.sub-line
  font-size 0.75rem
  text-transform lowercase
  padding-top: 5px
  color rgba(255,255,255,0.7) // jemnejšie oproti hlavnému textu
</style>
